import "../styles/app.scss";
import "slick-carousel/slick/slick.scss";
import "./_images";
import "./_animations";
import * as Helper from "./utils/helpers.js";
import DafYomiSlider from "./components/DafYomiSlider";
import GridSlider from "./components/GridSlider";
import OnlyRegistered from "./components/only-registered";
import TabsMobile from "./components/tabs-mobile";
import PopupTapestry from "./components/popup-tapestry";
import PrimarySlider from "./components/primarySlider";
import { setAnimatedIconDynamicLink } from "./utils/helpers.js";
import TapestrySlider from "./components/tapestrySlider";
import DafSpotify from "./components/daf-spotify";
import DafMark from "./components/daf-mark";
import PostPaginate from "./components/post-paginate";
import { ShareToggle } from "./components/socialShareButtonToggle";
import { DafSefariaToggle } from "./components/dafSefariaToggle";
import { CustomSelectSorting } from "./components/custom-select-sorting";
import { BdFilterInfo } from "./components/bd-filter-info";
import "./utils/monthly";
import DafCalendar from "./components/daf-calendar";
import Search from "./components/search";
import Login from "./components/login";
import MyAccount from "./components/my-account";
import { CurrentYear } from "./components/current-year";
import FloatingBar from "./components/floatingBar";
import NavMobile from "./components/nav-mobile";
import SearchPlaceholder from "./components/search-placeholder";
import { HeaderUserMenu } from "./components/header-user-menu";
import TodaysDaf from "./components/todays-daf";
import SiyumTabs from "./components/siyum-tabs";
import QuizProgressBar from "./components/quiz-progress-bar";
import SingleDaf from "./components/single-daf";
import LearnDash from "./components/learnDash";
import TabsSlider from "./components/tabs-slider";
import DafLearn from "./components/daf-learn";
import WikiLinks from "./components/wiki-links";
import Teachers from "./components/teachers";
import { HeaderBannerController } from "./components/header-banner-controller";
import { WikiFilterInfo } from "./components/wiki-filter-info";
import { TeachersMaterialFilterInfo } from "./components/teachers-material-filter-info";
import TeamMemberCardDescriptionHandler from "./components/team-member-description-handler";
import LibsynPlayer from "./components/libsyn-player";
import {PressFilterInfo} from "./components/press-filter-info";
import NewUserPopup from "./components/new-user-popup";
import LearndashCourseLesson from "./components/learndash-course-lessons";
import PushEngage from "./components/pushEngage";
import VisualTools from "./components/visual-tools";
import GSAPAnimations from "./components/gsap-animations";
import BaguetteBoxRtl from "./components/baguetteBox-rtl";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    Helper.setAnimatedIcon();
    new DafYomiSlider();
    new GridSlider();
    new OnlyRegistered();
    new TabsMobile();
    new PopupTapestry();
    new PrimarySlider();
    new TapestrySlider();
    new DafSpotify();
    new DafMark();
    new PostPaginate();
    new ShareToggle();
    new DafSefariaToggle();
    new BdFilterInfo({
      hasSearchSummary: true,
      modifyInputValue: true,
    });
    new CustomSelectSorting();
    new DafCalendar();
    new Search();
    new Login();
    new MyAccount();
    new CurrentYear();
    new FloatingBar();
    new NavMobile();
    new SearchPlaceholder();
    new HeaderUserMenu();
    new TodaysDaf();
    new SiyumTabs();
    new QuizProgressBar();
    new SingleDaf();
    new TabsSlider();
    new LearnDash();
    new DafLearn();
    new HeaderBannerController();
    new WikiLinks();
    new WikiFilterInfo({
      perPage: 16,
    });
    new TeachersMaterialFilterInfo({
      perPage: 12,
    });
    new Teachers();
    new TeamMemberCardDescriptionHandler();
    new LibsynPlayer();
    new TeamMemberCardDescriptionHandler();
    new PressFilterInfo({
        perPage: 12,
        modifyInputValue: true,
    });
    new NewUserPopup()
    new LearndashCourseLesson();
    new PushEngage();
    BaguetteBoxRtl.init();
    new VisualTools();
    //new GSAPAnimations();
  },
  false
);
